export default {
   auth: {
      passwordsNotMatch: { title: "", text: "The passwords doesn't match." },
      userAlreadyExist: {
         title: "",
         text: "User with this name already exists",
      },
      emailAlreadyExist: {
         title: "",
         text: "Sorry! This email is already registered.",
      },
      allFieldRequired: { title: "", text: "Please complete all the fields" },
      shortUserName: {
         title: "",
         text: "Username must be greater than 2 characters",
      },
      longUserName: {
         title: "",
         text: "Username shouldn't be greater than 20 characters",
      },
      shortPassword: {
         title: "",
         text: "Password should be 8 characters long.",
      },
      weakPassword: {
         title: "Weak password",
         text: "Please add special characters and numbers to your password to make it strong",
      },

      invalidEmail: {
         title: "Error",
         text: "The email entered has invalid format. Please enter correct email.",
      },
      wrongUsernameOrPass: {
         title: "Failed to login",
         text: "Wrong username or password. Please try again",
      },
      wrongOtp: {
         title: "Wrong Otp",
         text: "The otp you have entered is wrong. Please check it again",
      },
      resentOtpFail: {
         title: "Failed to resent otp",
         text: "You have already requested the otp 3 times. You can request it again.",
      },
      maxOtpTires: {
         title: "",
         text: "You have tried three times but failed. You cannot send the otp again.",
      },
      registerOtpExpired: {
         title: "OTP Expired",
         text: "Your otp has been expired. Please enter your details again",
      },
   },
   forgetPass: {
      emailNotRegistered: {
         title: "Error",
         text: "The email entered in is not registered.",
      },
      userNotVerified: {
         title: "Cannot reset password",
         text: "The email you have entered is not verified. You cannot request to reset password",
      },
      wrongOtp: {
         title: "Reset password failed",
         text: "You have failed to enter the correct otp",
      },
      otpExpired: {
         title: "OTP Expired",
         text: "The otp for resetting password is expired. Please try again",
      },
      cannotReset: {
         title: "Bad Request",
         text: "You cannot reset your password.",
      },
   },
   newGame: {
      duplicateName: {
         title: "Cannot choose this name.",
         text: "The name you have chosen has been already taken. Kindly change it to something else.",
      },
      gameFull: {
         title: "Max players reached.",
         text: "Game is already full. Please join another game",
      },
   },
};
